import React, { useState } from "react";
import styled from "styled-components";
import { H5 } from "../Texts";
import CloseIcon from "../../../assets/images/closeIcon.svg";

export const Style = styled.label`
  background: ${(props) => props.bg || "#F8F6FE"};
  border-radius: 4px;
  border: ${(props) =>
    (props.selected && props.selected === true
      ? "2px solid #442ECF"
      : "2px solid #E7E5F2") || props.border};
  transition: 0.3s ease-in;

  &:hover {
    border: ${(props) => props.hoverBorder || "2px solid #442ECF"};
  }

  &:focus {
    outline: none;
    border: 2px solid #442ecf;
  }
`;

const ListWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  grid-gap: 12px;
  margin-top: 10px;
`;

const FileList = styled.div`
  width: fit-to-content;
  cursor: pointer;
  border: 1px solid #442ed0;
  padding: 4px 8px;
  font-size: 12px;
  border-radius: 20px;
  background-color: white;
  position: relative;
`;

const Circle = styled.div`
  background-color: #e2e8f0;
  height: 16px;
  width: 16px;
  display: flex;
  border-radius: 50%;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  top: -8px;
  right: -8px;
`;

const Close = styled.img`
  height: 12px;
  width: 16px;
`;

export const MultipleFileInput = React.forwardRef(
  (
    {
      className,
      id,
      name,
      label,
      labelText,
      labelColor = "#1E202A",
      value,
      required,
      accept,
      files,
      maxFile,
      setFiles,
      ...rest
    },
    ref,
  ) => {
    const [errorMessage, setErrorMessage] = useState(null);

    const addFiles = (event) => {
      setErrorMessage(null);

      const _files = event.target.files;
      const maxSizeInBytes = 1 * 1024 * 1024; // 1 MB

      const validFiles = Array.from(_files).filter(
        (file) => file.size <= maxSizeInBytes,
      );

      const invalidFiles = Array.from(_files).filter(
        (file) => file.size > maxSizeInBytes,
      );

      // if there are any file above 1mb
      if (invalidFiles.length > 0) {
        setErrorMessage(
          `The following files exceed the size limit (1MB): ${invalidFiles
            .map((file) => file.name)
            .join(", ")}`,
        );
        event.target.value = null; // Clear the file input
      }

      setFiles([...files, ...validFiles]);
    };

    const removeFile = (file) => {
      const newFiles = files.filter((item) => item !== file); // Filter out the selected file
      setFiles(newFiles);
    };

    return (
      <>
        <Style
          htmlFor={id}
          className="p-10 flex flex-col justify-center items-center mx-auto relative cursor-pointer"
          button="Upload file"
          border=" solid 2px #E7E5F2"
          hoverBorder=" solid 2px #E7E5F2"
        >
          {errorMessage ? (
            <>
              <H5 fontSize="12px" color="#AD283D">
                {errorMessage}
              </H5>
            </>
          ) : label ? (
            label
          ) : (
            <H5 color="#0D024E">{labelText}</H5>
          )}

          <input
            type="file"
            accept={accept}
            multiple
            ref={ref}
            name={name}
            id={id}
            value={value}
            required={required}
            onChange={addFiles}
            className="w-0 h-0 opacity-0 absolute"
          />
        </Style>

        <ListWrap>
          {files?.length > 0 &&
            files?.map((file, index) => (
              <FileList
                onClick={() => removeFile(file)}
                key={index}
                className="italic"
              >
                {" "}
                {file?.name}
                <Circle>
                  <Close src={CloseIcon} alt="delete" />
                </Circle>
              </FileList>
            ))}
        </ListWrap>
      </>
    );
  },
);
